import { Teksten } from "../../../content";
import { IconLabelMolecule } from "../icon-label";
import { PopupMolecule } from "../popup";

interface Props {
  dossierAnnuleren: () => void;
  close: () => void;
}

export function PopupAnnuleerDossierMolecule(props: Readonly<Props>) {
  const alert = () => {
    return <IconLabelMolecule icon={"icon-alert-blue"} label={Teksten.dossierAnnuleren.alert} type={"default"} />;
  };

  return (
    <PopupMolecule
      title={Teksten.dossierAnnuleren.title}
      text={Teksten.dossierAnnuleren.tekst}
      cancelButton={{
        text: "Doorgaan met aanmaken",
        onClick: () => {
          props.close();
        },
      }}
      okeButton={{
        text: "Dossier annuleren",
        onClick: () => {
          props.dossierAnnuleren();
          props.close();
        },
      }}
      extraInfo={alert()}
    />
  );
}
